import {Plugins, withSystem, TypeImplementation} from '@packages/systems/wfdl';
import {TRecord, TTypeConstructor} from '@packages/systems/wfdl-ast';
import {typeName, qualify, iconName} from '@packages/systems/wfdl-Qualified';
import {ExpressionEditor} from '@packages/systems/ExpressionEditor-utils';
import React from 'react';

const type = TRecord({
  image: withSystem(
    {labelVariant: 'hidden', isLocalizable: true},
    TTypeConstructor(
      qualify(Plugins.name('Lightbox'), typeName('LightboxImage'))
    )
  ),
  caption: withSystem(
    {label: 'Caption', isLocalizable: true},
    TTypeConstructor(qualify(Plugins.name('Basic'), typeName('OnBlurText')))
  ),
});
export const LightboxImageAndCaptionType = TypeImplementation.Alias({
  type,
  icon: TypeImplementation.IconByName(
    qualify(Plugins.name('Basic'), iconName('Image'))
  ),
  render: function LightboxImageRender({expr, dispatch}) {
    return <ExpressionEditor expression={expr} dispatch={dispatch} />;
  },
});
